import React from 'react';

import NetworkConcernsContainer from '@totem/components/networkConcerns/networkConcernsContainer';
import NetworkConcernsLayout from '@totem/components/networkConcerns/networkConcernsLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const NetworkConcernsPage = () => {
  return (
    <ContentLayout>
      <NetworkConcernsContainer>
        <IBCard isCovered>
          <NetworkConcernsLayout />
        </IBCard>
      </NetworkConcernsContainer>
    </ContentLayout>
  );
};

export default NetworkConcernsPage;
